import React, { Component } from "react";
import { Col } from "reactstrap";
// react plugin used to create a form with multiple steps
import ReactWizard from "react-bootstrap-wizard";

import { PanelHeader } from "components";

import CustomerBasicData from "./CustomerBasicData.jsx";
import CustomerType from "./CustomerType.jsx";
import CustomerAddress from "./CustomerAddress.jsx";
import SweetAlert from "react-bootstrap-sweetalert";

import { Redirect } from "react-router-dom";

var steps = [
  {
    stepName: "Tipo de cliente",
    stepIcon: "now-ui-icons ui-1_settings-gear-63",
    component: CustomerType
  },
  {
    stepName: "Datos básicos",
    stepIcon: "now-ui-icons users_circle-08",
    component: CustomerBasicData
  },
  {
    stepName: "Dirección",
    stepIcon: "now-ui-icons location_map-big",
    component: CustomerAddress
  }
];

class CustomerWizard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCreateFromRequest: false,
      customerType: "",
      dni: "",
      name: "",
      lastname: "",
      lastname2: "",
      email: "",
      street: "",
      postalCode: "",
      city: "",
      province: "",
      comunity: "",
      mobile: "",
      iban: "",
      promoCode: "",
      fiscalIdType: "",
      dniManager: "",
      firstnameManager: "",
      lastnameManager: "",
      lastname2Manager: ""
    };

    if (this.props.mainState.createCustomerFromWebRequest) {
      // console.log("######### CREANDO CLIENTE DESDE WEBREQUEST #########");
      // console.log(this.props.mainState.createCustomerFromWebRequest);
      let requestCustomer = this.props.mainState.createCustomerFromWebRequest;
      let tipoCliente = 0;
      switch (requestCustomer.tipo_cliente_solicitud) {
        case "particular":
          tipoCliente = "89";
          break;
        case "autónomo": 
          tipoCliente = "91";
          break;
        case "empresa": 
          tipoCliente = "90";
          break;
        case "extranjero": 
          tipoCliente = "92";
          break;
        default:;
      }
      let tipoDocumento = null;
      switch (requestCustomer.tipo_documento_solicitud) {
        case "dni":
          tipoDocumento = { value: "93", label: "DNI" };
          break;
        case "nie": 
          tipoDocumento = { value: "94", label: "NIE" };
          break;
        case "pasaporte": 
          tipoDocumento = { value: "96", label: "Pasaporte" };
          break;
        case "nif": 
          tipoDocumento = { value: "95", label: "NIF" };
          break;
        default:;
      }
      this.state = {
        isCreateFromRequest: true,
        mobile_request: requestCustomer,
        customerType: tipoCliente,
        dni: requestCustomer.dni_solicitud,
        name: requestCustomer.nombre_completo_solicitud,
        lastname: requestCustomer.primer_apellido_solicitud,
        lastname2: requestCustomer.segundo_apellido_solicitud,
        email: requestCustomer.email_contacto_solicitud,
        street: requestCustomer.direccion_solicitud,
        postalCode: requestCustomer.codigo_postal,
        city: requestCustomer.localidad_solicitud,
        province: requestCustomer.provincia,
        comunity: "",
        mobile: requestCustomer.numero_contacto_solicitud,
        iban: requestCustomer.iban_solicitud,
        promoCode: requestCustomer.codigo_promocional,
        fiscalIdType: tipoDocumento,
        dniManager: requestCustomer.dni_gerente_solicitud,
        firstnameManager: requestCustomer.nombre_gerente_solicitud,
        lastnameManager: requestCustomer.primer_apellido_gerente_solicitud,
        lastname2Manager: requestCustomer.segundo_apellido_gerente_solicitud
      };
    }

    if (this.props.mainState.createCustomerFromContract) {
      let contract = this.props.mainState.createCustomerFromContract;
      this.state.contract_id = contract.id;
      this.state.contract = contract;

      // console.log("######### CREANDO CLIENTE DESDE CONTRATO #########");
      // console.log(this.props.mainState.createCustomerFromContract);
      // let tipoCliente = contract.customerType.value;
      Object.keys(contract.customerData).map(value => {
        this.state[value] = contract.customerData[value];
        if (value === "customerType") this.state[value] = contract.customerData.customerType.value;
        if (value === "firstname") this.state.name = contract.customerData.firstname;
        if (value === "locality") this.state.city = contract.customerData.locality;
      });
      this.state.fiscalIdType = contract.customerData.fiscalIdType;
      this.state.isCreateFromRequest = true;
      // this.state = {
      //   isCreateFromRequest: true,
      //   customerType: tipoCliente,
      //   dni: contract.dni_solicitud,
      //   // name: contract.nombre_completo_solicitud,
      //   // lastname: contract.primer_apellido_solicitud,
      //   // lastname2: contract.segundo_apellido_solicitud,
      //   // email: contract.email_contacto_solicitud,
      //   // street: contract.direccion_solicitud,
      //   // postalCode: contract.codigo_postal,
      //   // city: contract.localidad_solicitud,
      //   // province: contract.provincia,
      //   // comunity: "",
      //   // mobile: contract.numero_contacto_solicitud,
      //   // iban: contract.iban_solicitud,
      //   // promoCode: contract.codigo_promocional,
      //   // fiscalIdType: tipoDocumento,
      //   dniManager: contract.dni_gerente_solicitud,
      //   firstnameManager: contract.nombre_gerente_solicitud,
      //   lastnameManager: contract.primer_apellido_gerente_solicitud,
      //   lastname2Manager: contract.segundo_apellido_gerente_solicitud
      // };
    }

    this.onChange = this.onChange.bind(this);
    this.createCustomer = this.createCustomer.bind(this);
    this.getState = this.getState.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }

  getState() {
    return this.state;
  }

  onChange(field, value) {
    // console.log("############## WIZARD ONCHANGE ##################");
    // console.log(field + " --> " + value);
    // console.log("############## WIZARD ONCHANGE STATE ##################");
    // console.log(this.state);
    let auxState = this.state;
    auxState[field] = value;
    if (field === "customerType" && value === "90") auxState.fiscalIdType = "95";
    // if ((field === "customerType" && value === "90" && this.state.customerType !== "90") ||
    // (field === "customerType" && value !== "90" && this.state.customerType === "90")) {
    //   console.log("############## Dentro de cambio de tipo ##################");
    //   console.log(this.state);
    //   auxState.dni = "";
    //   auxState.name = "";
    //   auxState.lastname = "";
    //   auxState.lastname2 = "";
    //   auxState.dniManager = "";
    //   auxState.firstnameManager = "";
    //   auxState.lastnameManager = "";
    //   auxState.lastname2Manager = "";
    //   auxState.fiscalIdType = "";
    // }
    
    if (field === "customerType") {
      // console.log("############## Dentro de cambio de tipo (customerType) ##################");
      // console.log(this.state.customerType);
      auxState.dni = "";
      auxState.name = "";
      auxState.lastname = "";
      auxState.lastname2 = "";
      auxState.dniManager = "";
      auxState.firstnameManager = "";
      auxState.lastnameManager = "";
      auxState.lastname2Manager = "";
      auxState.fiscalIdType = "";
    }
    // console.log("############## WIZARD ONCHANGE ##################");
    // console.log(field + " --> " + value);
    // console.log("############## WIZARD ONCHANGE NEW STATE ##################");
    // console.log(auxState);
    this.setState(auxState);
  }

  createCustomer(customerData) {
    // console.log("############## WIZARD CREATE CUSTOMER ##################");
    // console.log(customerData);
    this.props.createCustomer(this.state);
  }

  componentDidUpdate(prevProps) {
    // Uso tipico (no olvides comparar los props):
    if (!this.props.mainState.isCreatingCustomer && prevProps.mainState.isCreatingCustomer
      && !this.props.mainState.isCreatingCustomerError) {
      this.setState({
        toCLientes: true
      });
    }
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }

  render() {
    // console.log("############## WIZARD STATE RENDER ##################");
    // console.log(this.state);
    if (this.state.toCLientes === true) {
      this.redirectTo("/clientes");
      // return <Redirect to="/clientes" />;
    }
    let wizardData = {
      mainState: this.props,
      onChange: this.onChange,
      wizardState: this.state,
      createCustomer: this.createCustomer,
      getState: this.getState
    };
    let isSearchingCustomer = null;
    if (this.props.mainState.isCreatingCustomer) {
      isSearchingCustomer = 
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="¡Un momentito!"
          onConfirm={() => this.hideAlert()}
          showConfirm={false}
        >
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
            {"  Creando cliente"}
        </SweetAlert>;
    }
    return (
      <div>
        <PanelHeader size="sm" />
        <div className="content">
          {isSearchingCustomer}
          <Col xs={12} md={10} className="mr-auto ml-auto">
            <ReactWizard
              steps={steps}
              navSteps
              validate
              title="Nuevo cliente"
              description="A continuación rellenaremos los campos del cliente"
              headerTextCenter
              color="blue"
              finishButtonClasses="btn-wd btn-success"
              nextButtonClasses="btn-wd btn-success"
              previousButtonClasses="btn-wd"
              wizardData={wizardData}
              finishButtonClick={this.createCustomer}
              finishButtonText="Crear"
              nextButtonText="Siguiente"
              previousButtonText="Anterior"
            />
          </Col>
        </div>
      </div>
    );
  }
}

export default CustomerWizard;



// WEBPACK FOOTER //
// ./src/views/Customers/CustomerWizard/CustomerWizard.jsx